import { Spinner } from "Components";
import { useEffect } from "react";
import { OPERATION_POSITION } from "src/constants/operation";
import CloseSummary from "./CloseSummary";
import OpenSummary from "./OpenSummary";
import { ArrowLeftOutlined } from "@ant-design/icons";

import "./Summary.scss";

//TODO prop types
const Summary = ({
  operation,
  onClickConfirm,
  onGetContraPosition,
  onClickEdit,
  contraPositions,
  onClickGoToOperate,
  setIsSumaryVisible,
  loading,
  submitting,
  optionType,
}: any) => {
  const isOpen = operation.position === OPERATION_POSITION.OPEN;

  useEffect(() => {
    if (operation.position === OPERATION_POSITION.CLOSE) onGetContraPosition();
  }, [operation]);

  return (
    <div className={isOpen ? "summary-container" : "summary-container close"}>
      <ArrowLeftOutlined className="arrow" onClick={() => onClickEdit()}/>
      {loading && <Spinner className="close" spinning={true} size="large" />}
      {isOpen ? (
        <OpenSummary
          operation={operation}
          onClickConfirm={onClickConfirm}
          submitting={submitting}
          optionType={optionType}
          onFinalize={() => setIsSumaryVisible(true)}
        />
      ) : (
        <CloseSummary
          operation={operation}
          onClickConfirm={onClickConfirm}
          loading={submitting}
          contraPositions={contraPositions}
          onClickGoToOperate={onClickGoToOperate}
          optionType={optionType}
          onFinalize={() => setIsSumaryVisible(true)}
        />
      )}
    </div>
  );
};

export default Summary;
